// Webpack Imports
import 'bootstrap';

function convertImages(query, callback) {
	const images = document.querySelectorAll(query);
	images.forEach(image => {
		fetch(image.src)
		.then(res => res.text())
		.then(data => {
			const parser = new DOMParser();
			const svg = parser
			.parseFromString(data, "image/svg+xml")
			.querySelector("svg");
			if (image.id) svg.id = image.id;
			if (image.className) svg.classList = image.classList;
			if ( image.parentNode ) {
				image.parentNode.replaceChild(svg, image);
			}
			
		})
		.then(callback)
		.catch(error => console.error(error));
	});
}

function find_page_number( element ) {
	
	element.find('span').remove();

	if(element.html().includes('Next')) {
		return element.attr('href').split('?paged=')[1];
	}

	return parseInt( element.html() );
}

( function ( $ ) {
	'use strict';
	
	convertImages("img.svg")

	AOS.init();

	$('.image-link').magnificPopup({type:'image'});
	$('.inline-popup').magnificPopup({type:'inline'});

	$('button.hamburger').click(function(){
		$(this).toggleClass('is-active');
		$('header .menu').toggleClass('menu-opened');
		$('body').toggleClass('menu-opened');
	})
	
	// Focus input if Searchform is empty
	$( '.search-form' ).on( 'submit', function ( e ) {
		var search = $( this ).find( 'input' );
		if ( search.val().length < 1 ) {
			e.preventDefault();
			search.trigger( 'focus' );
		}
	} );

	$(document).on( 'click', '.pagination a', function( e ) {
		e.preventDefault();

		var page = find_page_number( $(this).clone() );
		let latesetPost = parseInt($('.latest-post').find('article').attr('id').split('post-')[1]);

		$.ajax({
			url: '/wp-admin/admin-ajax.php',
			type: 'POST',
			dataType: 'html',
			data: {
				action: 'ajax_pagination',
				query_vars: ajaxpagination.query_vars,
				page: page,
				post__not_in: latesetPost
			},
			beforeSend: function() {
				$('.posts-tiles').hide();
				$("#loaderDiv").show();
			},
			success: function( res ) {
				setTimeout(() => {
					$('.posts-tiles').html(res);
					$('.posts-tiles').show();
					$("#loaderDiv").hide();
				}, 2000);
			}
        })
	})

	
}( jQuery ) );

